var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{attrs:{"fixed":true,"left-arrow":"","left-text":"返回"},on:{"click-left":_vm.onClickLeftBack}}),_c('div',{staticStyle:{"width":"100%","height":"50px"}}),_c('div',{staticClass:"list-view",style:({ height: _vm.screenHeight })},[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.videoData.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }